import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationType,
  MessageSettings
} from 'src/app/modules/communications/store/communications';

@Component({
    selector: 'topo-whatsapp-confirmation-control',
    templateUrl: './whatsapp-confirmation-control.component.html',
    styleUrls: ['./whatsapp-confirmation-control.component.scss'],
    standalone: false
})
export class WhatsappConfirmationControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;

  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this.confirmationText = !!this.messageSettings?.confirmationText
      ? this.templateDesignerService.getTranslateText(this.messageSettings?.confirmationText, value)
      : null;
    this.confirmationButtons = [];
    this.messageSettings?.confirmationButtons?.forEach(b => {
      this.confirmationButtons.push({
        uId: b.uId,
        number: b.number,
        type: b.type,
        text: this.templateDesignerService.getTranslateText(b.text, value)
      });
    });
  }
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  editMode: boolean;

  ConfirmationType = ConfirmationType;
  confirmationText: string;
  yesConfirmationText: string;
  noConfirmationText: string;
  confirmationButtons: { uId: string; number: number; type: ConfirmationType; text: string }[];

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;
  }

  edit(): void {}

  setRuntimeData(data: any): void {}
}
